var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "widget widget-primary" }, [
    _vm.myOffers.length > 0
      ? _c("div", [
          _c("h3", [
            _vm._v(_vm._s(_vm.$translate("Woerner::Template.offersTitle")))
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.myOffers.length > 0
      ? _c("div", { staticClass: "order-history-list" }, [
          _c("div", { staticClass: "container-header d-none d-md-flex mb-2" }, [
            _c("div", { staticClass: "col-md-10" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-2 text-right" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$translate(
                        "Woerner::Template.offerConfirmationOrderId"
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-2 text-right" }, [
                  _vm._v(
                    _vm._s(_vm.$translate("Ceres::Template.orderHistorySum"))
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-2 text-right" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$translate("Woerner::Template.offerConfirmationDate")
                    )
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-2 text-right" }, [
                  _vm._v(" ")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-4 text-right" }, [
                  _vm._v(
                    _vm._s(_vm.$translate("Ceres::Template.orderHistoryStatus"))
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-2" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$translate("Woerner::Template.offersMore")) +
                  "\n            "
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "order-item border-top" },
            _vm._l(_vm.myOffers, function(offer, index) {
              return _c(
                "div",
                {
                  staticClass: "accordion col-sm-12",
                  attrs: { id: "accordion_" + offer.order.id }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "row container-clickable border-top-0 border py-3 collapsed",
                      attrs: {
                        id: "heading_" + offer.order.id,
                        "data-toggle": "collapse",
                        "data-target": "#collapse_" + offer.order.id,
                        "aria-expanded": "false",
                        "aria-controls": "collapse_" + offer.order.id
                      }
                    },
                    [
                      _c("div", { staticClass: "col-md-10" }, [
                        _c("div", { staticClass: "row" }, [
                          _c("i", { staticClass: "fa fa-chevron-up" }),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-2" }, [
                            _c("div", {
                              domProps: { innerHTML: _vm._s(offer.order.id) }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-md-2 text-right" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "Ceres::Template.orderHistoryTotal"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm._f("currency")(
                                      offer.order.amounts[0].netTotal
                                    )
                                  ) +
                                  "\n                                "
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-lg-2 text-right" }, [
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(offer.order.anlage)
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-lg-2 text-right" }, [
                            _vm._v(
                              "\n                                 \n                            "
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-lg-4" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(offer.order.statusName) +
                                "\n                            "
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-2" }, [
                        _c("div", { staticClass: "icons d-none d-md-block" }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  "/bestellbestaetigung/?orderId=" +
                                  offer.order.id +
                                  "&typ=angebot",
                                target: "_blank",
                                rel: "noopener"
                              }
                            },
                            [
                              _c("i", {
                                directives: [
                                  { name: "tooltip", rawName: "v-tooltip" }
                                ],
                                staticClass:
                                  "fa fa-eye fa-flip-horizontal text-primary text-appearance",
                                attrs: {
                                  "aria-hidden": "true",
                                  "data-toggle": "tooltip",
                                  "data-placement": "top",
                                  title: "",
                                  "data-original-title": "Angebotdetails"
                                }
                              })
                            ]
                          )
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "collapse",
                      attrs: {
                        id: "collapse_" + offer.order.id,
                        "data-parent": "#accordion_" + offer.order.id
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "row container-middle border-right border-left border-bottom"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "col-lg-7 border-right" },
                            _vm._l(offer.item, function(item, index) {
                              return item.typeId != 6
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "cart-item row mt-3 align-items-center"
                                    },
                                    [
                                      _c("div", { staticClass: "col-12" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "row align-items-center"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "col-lg-2" },
                                              [
                                                _vm._l(
                                                  offer.variation,
                                                  function(offerVar) {
                                                    return [
                                                      item.itemVariationId ==
                                                      offerVar.id
                                                        ? [
                                                            _c("img", {
                                                              staticClass:
                                                                "img-fluid",
                                                              attrs: {
                                                                src:
                                                                  offerVar.data
                                                                    .images
                                                                    .all[0]
                                                                    .urlPreview
                                                              }
                                                            })
                                                          ]
                                                        : _vm._e()
                                                    ]
                                                  }
                                                )
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "col-lg-10" },
                                              [
                                                _vm._l(
                                                  offer.variation,
                                                  function(offerVar) {
                                                    return [
                                                      item.itemVariationId ==
                                                      offerVar.id
                                                        ? [
                                                            _c("a", {
                                                              staticClass:
                                                                "text-primary",
                                                              attrs: {
                                                                href:
                                                                  "/" +
                                                                  offerVar.data
                                                                    .texts
                                                                    .urlPath +
                                                                  "_" +
                                                                  offerVar.data
                                                                    .texts
                                                                    .itemId,
                                                                target: "_blank"
                                                              },
                                                              domProps: {
                                                                innerHTML: _vm._s(
                                                                  item.orderItemName
                                                                )
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "row"
                                                              },
                                                              [
                                                                _c(
                                                                  "strong",
                                                                  {
                                                                    staticClass:
                                                                      "col-6 col-sm-3 col-md-5"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$translate(
                                                                          "Ceres::Template.basketItemNumber"
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "col-6 col-sm-9 col-md-7 text-right"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        offerVar
                                                                          .data
                                                                          .variation
                                                                          .number
                                                                      )
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        : _vm._e()
                                                    ]
                                                  }
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "item-details mt-0"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "row" },
                                                      [
                                                        _c(
                                                          "strong",
                                                          {
                                                            staticClass:
                                                              "col-6 col-sm-3 col-md-5"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$translate(
                                                                  "Ceres::Template.orderConfirmationPricePerPiece"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "col-6 col-sm-9 col-md-7 text-right"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm._f(
                                                                  "currency"
                                                                )(
                                                                  item
                                                                    .amounts[0]
                                                                    .priceOriginalNet
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    item.amounts[0]
                                                      .priceOriginalNet -
                                                      item.amounts[0].priceNet >
                                                    0
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "row rebate-hint"
                                                          },
                                                          [
                                                            _c(
                                                              "strong",
                                                              {
                                                                staticClass:
                                                                  "col-6 col-sm-3 col-md-5"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$translate(
                                                                      "Ceres::Template.orderHistoryItemDiscount"
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "col-6 col-sm-9 col-md-7 text-right"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "currency"
                                                                    )(
                                                                      item
                                                                        .amounts[0]
                                                                        .priceOriginalNet -
                                                                        item
                                                                          .amounts[0]
                                                                          .priceNet
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      { staticClass: "row" },
                                                      [
                                                        _c(
                                                          "strong",
                                                          {
                                                            staticClass:
                                                              "col-6 col-sm-3 col-md-5"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$translate(
                                                                  "Ceres::Template.orderHistoryQuantity"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "col-6 col-sm-9 col-md-7 text-right"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.quantity
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      offer.variation,
                                                      function(offerVar) {
                                                        return [
                                                          item.itemVariationId ==
                                                          offerVar.id
                                                            ? [
                                                                offerVar.data
                                                                  .attributes
                                                                  .length > 0
                                                                  ? [
                                                                      _vm._l(
                                                                        offerVar
                                                                          .data
                                                                          .attributes,
                                                                        function(
                                                                          attr
                                                                        ) {
                                                                          return _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "row"
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "strong",
                                                                                {
                                                                                  staticClass:
                                                                                    "col-6 col-sm-3 col-md-5"
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      attr
                                                                                        .attribute
                                                                                        .names
                                                                                        .name
                                                                                    )
                                                                                  )
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "col-6 col-sm-9 col-md-7 text-right"
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      attr
                                                                                        .value
                                                                                        .names
                                                                                        .name
                                                                                    )
                                                                                  )
                                                                                ]
                                                                              )
                                                                            ]
                                                                          )
                                                                        }
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "row"
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "strong",
                                                                            {
                                                                              staticClass:
                                                                                "col-6 col-sm-3 col-md-5"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm.$translate(
                                                                                    "Woerner::Template.basketUnit"
                                                                                  )
                                                                                )
                                                                              )
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            " "
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "col-6 col-sm-9 col-md-7 text-right"
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  offerVar
                                                                                    .data
                                                                                    .unit
                                                                                    .names
                                                                                    .name
                                                                                )
                                                                              )
                                                                            ]
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  : _vm._e()
                                                              ]
                                                            : _vm._e()
                                                        ]
                                                      }
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      { staticClass: "row" },
                                                      [
                                                        _c(
                                                          "strong",
                                                          {
                                                            staticClass:
                                                              "col-6 col-sm-3 col-md-5"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$translate(
                                                                  "Ceres::Template.orderConfirmationTotal"
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "strong",
                                                          {
                                                            staticClass:
                                                              "col-6 col-sm-9 col-md-7 text-right"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm._f(
                                                                  "currency"
                                                                )(
                                                                  item
                                                                    .amounts[0]
                                                                    .priceNet *
                                                                    item.quantity
                                                                )
                                                              ) + "  "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  2
                                                )
                                              ],
                                              2
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-lg-5" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "cmp cmp-totals pt-3 d-flex sticky-element mt-3"
                              },
                              [
                                _c("div", { staticClass: "cmp cmp-totals" }, [
                                  _c("h3", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.orderHistorySum"
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c(
                                      "dl",
                                      { staticClass: "d-flex flex-wrap" },
                                      [
                                        offer.rabat > 0
                                          ? [
                                              _c(
                                                "dt",
                                                {
                                                  staticClass:
                                                    "font-weight-bold"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                    " +
                                                      _vm._s(
                                                        _vm.$translate(
                                                          "Ceres::Template.basketValue"
                                                        )
                                                      ) +
                                                      " (" +
                                                      _vm._s(
                                                        _vm.$translate(
                                                          "Ceres::Template.checkoutNet"
                                                        )
                                                      ) +
                                                      ")\n                                                "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "dd",
                                                {
                                                  staticClass:
                                                    "font-weight-bold"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                    " +
                                                      _vm._s(
                                                        _vm._f("currency")(
                                                          offer.order.amounts[0]
                                                            .netTotal +
                                                            offer.rabat
                                                        )
                                                      ) +
                                                      "\n                                                "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "dt",
                                                { staticClass: "rebate-hint" },
                                                [
                                                  _vm._v(
                                                    "\n                                                    " +
                                                      _vm._s(
                                                        _vm.$translate(
                                                          "Ceres::Template.orderHistoryRebate"
                                                        )
                                                      ) +
                                                      "\n                                                "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "dd",
                                                { staticClass: "rebate-hint" },
                                                [
                                                  _vm._v(
                                                    "\n                                                    " +
                                                      _vm._s(
                                                        _vm._f("currency")(
                                                          offer.rabat
                                                        )
                                                      ) +
                                                      "\n                                                "
                                                  )
                                                ]
                                              )
                                            ]
                                          : [
                                              _c(
                                                "dt",
                                                {
                                                  staticClass:
                                                    "font-weight-bold"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                    " +
                                                      _vm._s(
                                                        _vm.$translate(
                                                          "Ceres::Template.basketValue"
                                                        )
                                                      ) +
                                                      " (" +
                                                      _vm._s(
                                                        _vm.$translate(
                                                          "Ceres::Template.checkoutNet"
                                                        )
                                                      ) +
                                                      ")\n                                                "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "dd",
                                                {
                                                  staticClass:
                                                    "font-weight-bold"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                    " +
                                                      _vm._s(
                                                        _vm._f("currency")(
                                                          offer.order.amounts[0]
                                                            .netTotal
                                                        )
                                                      ) +
                                                      "\n                                                "
                                                  )
                                                ]
                                              )
                                            ],
                                        _vm._v(" "),
                                        _c(
                                          "dt",
                                          { staticClass: "font-weight-bold" },
                                          [
                                            _vm._v(
                                              "\n                                                " +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.orderHistoryShippingCosts"
                                                  )
                                                ) +
                                                " (" +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.checkoutNet"
                                                  )
                                                ) +
                                                ")\n                                            "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "dd",
                                          { staticClass: "font-weight-bold" },
                                          [
                                            offer.order.amounts[0]
                                              .shippingCostsNet == 0
                                              ? [
                                                  _vm._v(
                                                    "\n                                                    " +
                                                      _vm._s(
                                                        _vm.$translate(
                                                          "Woerner::Template.versandBerechnungLaeuft"
                                                        )
                                                      ) +
                                                      "\n                                                "
                                                  )
                                                ]
                                              : [
                                                  _vm._v(
                                                    "\n                                                    " +
                                                      _vm._s(
                                                        _vm._f("currency")(
                                                          offer.order.amounts[0]
                                                            .shippingCostsNet
                                                        )
                                                      ) +
                                                      "\n                                                "
                                                  )
                                                ]
                                          ],
                                          2
                                        ),
                                        _vm._v(" "),
                                        _c("hr", { staticClass: "w-100" }),
                                        _vm._v(" "),
                                        _c(
                                          "dt",
                                          { staticClass: "font-weight-bold" },
                                          [
                                            _vm._v(
                                              "\n                                                " +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.orderHistoryTotalSum"
                                                  )
                                                ) +
                                                " (" +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.checkoutNet"
                                                  )
                                                ) +
                                                ")\n                                            "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "dd",
                                          { staticClass: "font-weight-bold" },
                                          [
                                            _vm._v(
                                              "\n                                                " +
                                                _vm._s(
                                                  _vm._f("currency")(
                                                    offer.order.amounts[0]
                                                      .netTotal
                                                  )
                                                ) +
                                                "\n                                            "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "vatTotals d-flex w-100"
                                          },
                                          [
                                            _c("dt", [
                                              _vm._v(
                                                "\n                                                    MwSt. "
                                              ),
                                              _c("span", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    offer.order.amounts[0]
                                                      .vats[0].vatRate
                                                  )
                                                }
                                              }),
                                              _vm._v(
                                                " %\n                                                "
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("dd", [
                                              _vm._v(
                                                "\n                                                    " +
                                                  _vm._s(
                                                    _vm._f("currency")(
                                                      offer.order.amounts[0]
                                                        .vats[0].value
                                                    )
                                                  ) +
                                                  "\n                                                "
                                              )
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "totalSum d-flex w-100 flex-wrap"
                                          },
                                          [
                                            _c("hr", { staticClass: "w-100" }),
                                            _vm._v(" "),
                                            _c("dt", [
                                              _vm._v(
                                                "\n                                                    " +
                                                  _vm._s(
                                                    _vm.$translate(
                                                      "Ceres::Template.orderHistoryTotalSum"
                                                    )
                                                  ) +
                                                  " (" +
                                                  _vm._s(
                                                    _vm.$translate(
                                                      "Ceres::Template.orderHistoryGross"
                                                    )
                                                  ) +
                                                  ")\n                                                "
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c("dd", [
                                              _vm._v(
                                                "\n                                                    " +
                                                  _vm._s(
                                                    _vm._f("currency")(
                                                      offer.order.amounts[0]
                                                        .grossTotal
                                                    )
                                                  ) +
                                                  "\n                                                "
                                              )
                                            ])
                                          ]
                                        )
                                      ],
                                      2
                                    )
                                  ])
                                ])
                              ]
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ]
              )
            }),
            0
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }